import { CONTAINER_BOX_SHADOW } from '~/Constants/CSS.constants';
import { makeStyles } from '~/UIKit/Style';

export const EventScheduleTimeSeriesStyles = makeStyles((theme) => ({
  TimeSeriesRoot: {
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '0 15px',
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
    },
  },
  TimeSeriesListContainer: {
    marginTop: 30,
    width: '100%',
    boxShadow: CONTAINER_BOX_SHADOW,
  },
  TimeSeriesCreationButton: {
    width: 158,
    marginTop: 30,
    marginBottom: 30,
  },
}));
